import { observer } from 'mobx-react'
import './index.scss'
import { ReactComponent as Package } from '../../../assets/track/Group 48095705.svg'
import { useEffect } from 'react'
import GlobalState from '../../../stores/GlobalState'

const ErrorBlock = observer(() => {
  const contentUA = {
    title: 'Щось пішло не так',
    text: `Але ми вже працюємо над цим. Повторіть спробу через 5 хвилин.`,
    buttonTitle: 'Повторити',
  }
  const contentEN = {
    title: 'Something goes wrong',
    text: `But we are already working on it. Try again in 5 minutes.`,
    buttonTitle: 'Try again',
  }

  const contentRU = {
    title: 'Что-то пошло не так',
    text: `Но мы уже работаем над этим. Повторите попытку через 5 минут.`,
    buttonTitle: 'Повторить',
  }

  const content = GlobalState.currentLocale.lang.includes('En')
    ? contentEN
    : GlobalState.currentLocale.lang.includes('ру')
    ? contentRU
    : contentUA

  useEffect(() => {
    const header = document.querySelector('.header')

    if (header) {
      ;(document.querySelector(
        '.error-block',
      ) as HTMLElement)?.style.setProperty(
        '--header-height',
        header.getBoundingClientRect().height + 'px',
      )
    }
  }, [])
  return (
    <section className="error-block">
      <Package className="error-block__img" />
      <div
        className="error-block__title"
        dangerouslySetInnerHTML={{ __html: content.title }}
      ></div>
      <div
        className="error-block__text"
        dangerouslySetInnerHTML={{ __html: content.text }}
      ></div>
      <div
        className="button black"
        onClick={() => {
          window.history.back()
          // window.location.reload()
        }}
      >
        {content.buttonTitle}
      </div>
    </section>
  )
})

export default ErrorBlock
